import { CheckCircle2, AlertCircle, MailX } from "lucide-react";

/** Compact pill showing whether the most recent email send for this entity succeeded.
 * Pass either {status} (the last_email_status object from the API) or null/undefined.
 */
export default function EmailStatusBadge({ status, testid }) {
  if (!status) {
    return (
      <span data-testid={testid}
        className="inline-flex items-center gap-1 text-[10px] text-[var(--ink-3)] font-mono"
        title="No email sent yet">
        <MailX size={10} /> not sent
      </span>
    );
  }
  if (status.ok) {
    return (
      <span data-testid={testid}
        className="inline-flex items-center gap-1 text-[10px] font-mono"
        style={{ color: "var(--moss)" }}
        title={`Delivered to ${status.to} · ${status.sent_at}`}>
        <CheckCircle2 size={10} /> delivered
      </span>
    );
  }
  // Failure — surface the reason on hover and as truncated text
  const reason = status.error || "delivery failed";
  const short = reason.length > 36 ? reason.slice(0, 36) + "…" : reason;
  return (
    <span data-testid={testid}
      className="inline-flex items-center gap-1 text-[10px] font-mono"
      style={{ color: "var(--accent)" }}
      title={`Failed to send to ${status.to}: ${reason}`}>
      <AlertCircle size={10} /> {short}
    </span>
  );
}
